import styled from "@emotion/styled";
import { color } from "./color";

export const RaceOutter = styled.div`
  width: 100%;
  background-color: ${color.secondary};
  padding: 1rem 0;
`;
export const BackOutter = styled.div`
  display: flex;
  width: 100%;
  flex-flow: row wrap;
  align-items: center;
  text-align: center;
  margin-bottom: 0.5rem;
  @media print {
    display: none;
  }
  .trainning {
    display: flex;
    flex-flow: row wrap;
    &:first-of-type {
      width: 30%;
    }
    width: 35%;
  }
  .colOne {
    font-weight: bolder;
    background-color: ${(props: { isMatch: boolean }) =>
      props.isMatch ? "red" : "#ffd166"};
    padding: 0.5rem;
    flex: 0 1 100%;
    border-top-left-radius: 0.3rem;
    border-top-right-radius: 0.3rem;
    @media (min-width: 865px) {
      padding: 1.2rem 2rem;
      border-bottom-left-radius: 0.3rem;
      border-top-right-radius: 0rem;
      flex: 0 1 30%;
    }
    @media (-ms-high-contrast: active), (-ms-high-contrast: none) {
      -ms-flex: 1 0 0%;
      border: 1px solid
        ${(props: { isMatch: boolean }) => (props.isMatch ? "red" : "#ffd166")};
      @media (min-width: 768px) {
        border: none;
      }
    }
  }
  .colTwo {
    display: flex;
    flex-flow: row nowrap;
    justify-content: space-around;
    flex: 0 1 100%;
    background-color: white;
    border-top: 1px solid
      ${(props: { isMatch: boolean }) => (props.isMatch ? "red" : "#ffd166")};
    border-bottom: 1px solid
      ${(props: { isMatch: boolean }) => (props.isMatch ? "red" : "#ffd166")};
    border-right: 1px solid
      ${(props: { isMatch: boolean }) => (props.isMatch ? "red" : "#ffd166")};
    border-left: 1px solid
      ${(props: { isMatch: boolean }) => (props.isMatch ? "red" : "#ffd166")};
    padding: 0.5rem;
    border-bottom-right-radius: 0.3rem;
    border-bottom-left-radius: 0.3rem;
    @media (min-width: 865px) {
      padding: 1.7rem 2rem;
      flex: 0 1 70%;
      border-left: none;
      border-bottom-left-radius: 0rem;
      border-top-right-radius: 0.3rem;
    }
    @media (-ms-high-contrast: active), (-ms-high-contrast: none) {
      -ms-flex: 1 0 0%;
      padding: 1rem 2rem;
    }
    .flexCol {
      margin: 0 1rem;
    }
  }
  .num {
    font-size: 0.8rem;
    color: ${color.default};
    @media (min-width: 576px) {
      font-size: 1rem;
    }
  }
  .num.first {
    font-size: 2rem;
    color: white;
    .totalPigeon {
      font-size: 1.2rem;
      display: inline-block;
    }
  }
  .text {
    color: ${color.default};
    font-size: 0.8rem;
    @media (min-width: 768px) {
      font-size: 1rem;
    }
  }
`;
export const TopTrainingBox = styled.div`
  width: 100%;
  display: flex;
  flex-flow: row wrap;
  border-radius: 0.5rem;
  border: 1px solid
    ${(props: { isMatch: boolean }) => (props.isMatch ? "red" : "#ffd166")};
  .trainning {
    padding: 1rem;
    display: flex;
    justify-content: center;
    align-items: center;
    flex-flow: row nowrap;
    color: ${color.default};
    width: 50%;
    text-align: center;
    &:first-of-type {
      color: ${color.primaryBlue};
      font-size: 1.12rem;
      font-weight: 600;
      background-color: ${(props: { isMatch: boolean }) =>
        props.isMatch ? "red" : "#ffd166"};
      width: 100%;
    }
    @media (min-width: 768px) {
      width: 35%;
      padding: 1rem 2rem;
      flex-flow: column nowrap;
      &:first-of-type {
        color: ${color.primaryBlue};
        font-size: 1.12rem;
        font-weight: 600;
        background-color: #ffd166;
        width: 30%;
      }
    }
  }
`;
export const StyledTable = styled.table`
  width: 100%;
  margin-top: 0.5rem;
  table-layout: auto;
  border-collapse: separate;
  border-spacing: 0;
  white-space: nowrap;
  background-color: white;
  border-radius: 0.5rem;
  @media (min-width: 576px) {
    table-layout: auto;
  }
  @media print {
    display: none;
  }
  tr {
    text-align: center;
    font-weight: bolder;
  }
  td {
    border-left: 1px solid ${color.default};
    border-top: 1px solid ${color.default};
    padding: 0.2rem 0.5rem;
    color: ${color.default};
    font-size: 1rem;
  }
  thead td {
    &:first-of-type {
      border-top-left-radius: 0.3rem;
    }
    &:last-of-type {
      border-top-right-radius: 0.3rem;
      border-right: 1px solid ${color.default};
    }
  }
  tbody td {
    font-weight: normal;
    &:first-of-type {
      border-bottom-left-radius: 0.3rem;
    }
    &:last-of-type {
      border-bottom-right-radius: 0.3rem;
      border-right: 1px solid ${color.default};
    }
    border-bottom: 1px solid ${color.default};
  }
`;
export const MatchPlace = styled.div`
  display: flex;
  flex-flow: row wrap;
  align-items: baseline;
  color: ${color.default};
  /* margin-bottom: .5rem; */
  .matchLocation {
    font-size: 1.5rem;
    margin-right: 0.5rem;
    font-weight: bolder;
    color: ${color.primaryBlue};
    cursor: pointer;
  }
  .expire {
    font-size: 0.8rem;
    margin-right: 0.5rem;
    @media (min-width: 768px) {
      font-size: 1rem;
      &:last-of-type {
        margin-left: auto;
      }
    }
  }
`;
export const GradeDetail = styled.div`
  margin-top: 1rem;
  .tab {
    position: relative;
    .ant-tabs-tab {
      background-color: ${color.secondary};
      .ant-tabs-tab-btn {
        color: ${color.default};
      }
      border-top-right-radius: 0.5rem !important;
      border-top-left-radius: 0.5rem !important;
    }
    .ant-tabs-nav .ant-tabs-tab-active {
      background-color: ${color.markedDefault};
      .ant-tabs-tab-btn {
        color: ${color.primaryBlue};
      }
    }
  }
  .searchBox {
    position: relative;
    display: flex;
    flex-flow: row wrap;
    justify-content: space-between;
    @media (min-width: 768px) {
      justify-content: flex-start;
    }
    @media print {
      display: none;
    }
    input {
      width: 48%;
      border-radius: 0.3rem;
      margin: 1rem 0;
      padding: 0.2rem 0.5rem;
      border: 1px solid ${color.default};
      @media (min-width: 768px) {
        margin: 1rem 0.5rem 0rem 0.5rem;
        width: 25%;
        outline: none;
        &:first-of-type {
          margin-left: 0rem;
        }
      }
    }
  }
  .functionBox {
    button {
      margin: 0rem 0.5rem 0rem 0rem;
      color: white;
      padding: 0.2rem 0.5rem;
      border: 1px solid ${color.markedSecondary};
      background-color: ${color.markedSecondary};
      border-radius: 0.3rem;
      transition: all 0.3s;
      cursor: pointer;
      @media (min-width: 768px) {
        margin: 1rem 0.5rem 0 0;
      }
      &:hover {
        border: 1px solid ${color.markedSecondary};
        background-color: ${color.markedSecondary};
      }
      &:last-of-type {
        background-color: white;
        color: ${color.markedSecondary};
        &:hover {
          background-color: ${color.markedSecondary};
          color: white;
        }
      }
      &:disabled {
        background-color: ${color.secondary};
        border: 1px solid ${color.secondary};
        color: ${color.default};
      }
    }
  }
  .warninng {
    color: ${color.warnning};
    font-weight: bolder;
    font-size: 0.6rem;
    margin-bottom: 1rem;
    @media (min-width: 768px) {
      margin-bottom: 0rem;
      font-size: 1rem;
      position: absolute;
      right: 0;
      top: 10%;
    }
  }
  .ant-pagination-total-text {
    margin-right: auto;
  }
  th.ant-table-cell {
    background-color: ${color.primaryBlue} !important;
    color: white;
    border-bottom: none;
    &:first-of-type {
      border-top-left-radius: 0.5rem !important;
    }
    &:last-of-type {
      border-top-right-radius: 0.5rem !important;
      border-right: 0px solid ${color.primaryBlue};
    }
  }
  td.ant-table-cell {
    border-bottom: 1px solid ${color.primaryBlue};
    border-right: 1px solid ${color.primaryBlue} !important;
    &:first-of-type {
      border-left: 1px solid ${color.primaryBlue};
    }
  }
  .ant-table-row {
    &:nth-of-type(odd) {
      background-color: ${color.secondary};
    }
    &:nth-of-type(even) {
      background-color: white;
    }
    @media print {
      page-break-inside: avoid;
    }
  }
  .ant-table-container {
    border-bottom: 1px black solid;
  }
  .ant-table-sticky-scroll-bar {
    position: absolute;
    bottom: 30%;
    height: 10px;
    background-color: rgba(0, 0, 0, 0.5);
  }
  .ant-table-tbody > tr.ant-table-row:hover > td {
    background-color: #ffe0a3;
  }
`;
